var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPetProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Pets-Paw-Search--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Pets Paw Search Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.41 20.59 -4.21 -4.22a10.51 10.51 0 1 0 -2.83 2.83l4.22 4.21a2 2 0 0 0 2.82 -2.82ZM10.5 2A8.5 8.5 0 1 1 2 10.5 8.51 8.51 0 0 1 10.5 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.34 15.89H8.63A1.65 1.65 0 0 1 7.18 15a1.7 1.7 0 0 1 0.13 -1.74l1.86 -2.52a1.63 1.63 0 0 1 2.63 0l1.85 2.54a1.66 1.66 0 0 1 -1.31 2.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67 10.81a1.69 1.69 0 1 1 1.69 -1.68 1.69 1.69 0 0 1 -1.69 1.68Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.47 8.28a1.69 1.69 0 1 1 1.69 -1.68 1.69 1.69 0 0 1 -1.69 1.68Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 10.81A1.69 1.69 0 1 1 16 9.13a1.68 1.68 0 0 1 -1.7 1.68Z",
    fill: "currentColor",
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPetProtection);
export default ForwardRef;